require('../modules/es6.object.to-string');
require('../modules/web.dom.iterable');
require('../modules/es6.weak-set');
module.exports = require('../modules/_core').WeakSet;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es6/weak-set.js
// module id = 765
// module chunks = 1